import React from 'react';
import dynamic from 'next/dynamic';
import Div100vh from 'react-div-100vh';
import { Restaurant } from '@firsttable/types';

const RestaurantMap = dynamic(() => import('../../RestaurantMap'), { ssr: false });

type MapModalProps = {
  restaurant: Restaurant;
};

const MapModal = ({ restaurant }: MapModalProps) => (
  <Div100vh>
    <RestaurantMap restaurants={[restaurant]} />
  </Div100vh>
);

export default MapModal;
